/**
 * Created by Ning Jiang on 2022-08-31.
 */

import {ReelStopPresentationController} from "../ReelStopPresentationController";
import {IReelStateEventData, ReelState} from "../../../core/reel/ReelState";
import {Serial} from "../../Serial";
import {SerialSound} from "../../sound/SerialSound";
import {ReelPositionController} from "../../reels/ReelPositionController";
import {Layers, SerialLayers} from "../../view/SerialLayers";

export class BigWinNearWinController extends ReelStopPresentationController {

    private _defaultNearWinSpinStepDuration:number = 0.02;
    private _nearWinReel:number = -1;

    private _spine:PIXI.spine.Spine;

    constructor() {
        super("BigWinNearWinController");
    }

    protected onReelBounce(data:IReelStateEventData):Promise<any> {
        const reel = Serial.reels[data.reelId];
        if(reel.isQuickStop) {
            if(this._nearWinReel > -1) {
                this.stopNearWin(data.reelId);
            }
            return Promise.resolve();
        }

        // Find the next spinning reel.
        const nearWinId = this.findNextNearWinReel(data.reelId);
        if(nearWinId < 0) {
            if(this._nearWinReel > -1) {
                this.stopNearWin(data.reelId);
            }
            return Promise.resolve();
        }

        // if(this._nearWinReel > -1 && !Serial.reelStopSoundController.stopSoundPlayed[data.reelId][0]) {
        //     Serial.reelStopSoundController.stopSoundPlayed[data.reelId][0] = true;
        //     SerialSound.soundPlayer.playTrack({name : SerialSound.ANTICIPATION_REEL_STOP});
        // }
        this.setReelNearWinSpin(nearWinId);
        this.playNearWin(nearWinId);
        return Promise.resolve();
    }

    private findNextNearWinReel(reelId:number):number {
        do {
            reelId++;
        } while(reelId < 5 && Serial.reels[reelId].reelState !== ReelState.SPIN && Serial.reels[reelId].reelState !== ReelState.STOPPING);

        if(reelId < 5 && !Serial.model.parsedGameData.nearWinReels[reelId] && Serial.model.parsedGameData.nearWinBigWinReels[reelId]) {
            return reelId;
        } else {
            return -1;
        }
    }

    private setReelNearWinSpin(reelId:number):void {
        if(Serial.reels[reelId].reelView.nextSpinStepConfig) {
            Serial.reels[reelId].reelView.nextSpinStepConfig!.duration = this._defaultNearWinSpinStepDuration;
        } else {
            Serial.reels[reelId].reelView.nextSpinStepConfig = {
                duration : this._defaultNearWinSpinStepDuration,
            }
        }
    }

    private playNearWin(reelId:number):void {
        if(this._nearWinReel < 0) {
            SerialSound.fadeMusic(0.3, 1);
            SerialSound.soundPlayer.playTrack({name : SerialSound.ANTICIPATION_BIG_WIN});
        }
        this._nearWinReel = reelId;
        if(!this._spine) {
            this._spine = new PIXI.spine.Spine(Serial.assetLoader.getSpineAsset(`bigWinNearWin`));
            this._spine.autoUpdate = true;
        }
        this._spine.position.set(ReelPositionController.REEL_AREAS[this._nearWinReel].x, 384);
        SerialLayers.getLayer(Layers.NEAR_WIN)!.addChild(this._spine);
        this._spine.state.setAnimation(0, this.getAnimationName(), true);
    }

    private getAnimationName():string {
        const mode = Serial.model.parsedGameData.mode;
        if(mode.includes("SUPER")) {
            return "SFS";
        }
        if(mode.includes("FREESPIN")) {
            return "FS";
        }
        return "MAIN";
    }

    private stopNearWin(reelId:number):void {
        if(this._spine) {
            this._spine.state.clearTrack(0);
            this._spine.skeleton.setToSetupPose();
            this._spine.state.setEmptyAnimation(0, 0);
            if(this._spine.parent) {
                this._spine.parent.removeChild(this._spine);
            }
        }
        SerialSound.fadeMusic(1, 1);
        SerialSound.soundPlayer.stopTrack(SerialSound.ANTICIPATION_BIG_WIN);
        if(!Serial.reelStopSoundController.stopSoundPlayed[reelId][0]) {
            Serial.reelStopSoundController.stopSoundPlayed[reelId][0] = true;
            SerialSound.soundPlayer.playTrack({name : SerialSound.ANTICIPATION_FAIL});
        }
        this._nearWinReel = -1;
    }
}